import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtService } from 'app/generic/JwtService';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChiSiamoService extends JwtService {

  constructor(private http: HttpClient,
    public router: Router,
    public modalComponent: NewModalService) {
    super(router, modalComponent);
  }

  findAllContatti(): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/contatti/findAll', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  findAllOrganigramma(): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/organigramma/findAll', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  findAllDescrizione(): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/extra/findAll', super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }
  findExtraById(idExtraAsset): Promise<any> {
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/extra/findById/'+idExtraAsset, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }
}
